import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

import DashboardLayout from "../pages/_layouts/dashboard";
import LoginLayout from "../pages/_layouts/login";

export default function RouteWrapper({
  component: Component,
  isPrivate,
  active,
  submenu,
  signed,
  ...rest
}) {

  const Layout = signed ? DashboardLayout : LoginLayout;

  return (
    <Route
      {...rest}
      render={props => (
        <Layout active={active} submenu={submenu}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}
